import React from 'react';
import classNames from 'classnames';
import AntRow from 'antd/lib/row';
import './style';

function Row({ children, className, ...rest }) {
  const computedClassName = classNames('bsa-row', className);

  return (
    <AntRow className={computedClassName} {...rest}>
      {children}
    </AntRow>
  );
}

Row.propTypes = AntRow.propTypes;
Row.defaultProps = AntRow.defaultProps;

export default Row;
